import React from 'react';

//  Components
import MessageForm from '../../components/Forms/MessageForm';

const Contact = () => {
    return <MessageForm/>;
}

export default Contact;